import api from 'store/api';
import {
  ScheduleEmployee,
  ScheduleEmployeeFilters,
  ScheduleEmployeePatchMutationRequest,
  ScheduleEmployeePostMutationRequest,
  ScheduleEmployeesData,
} from './interfaces';

export const scheduleEmployeesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getScheduleEmployees: builder.query<
      ScheduleEmployeesData,
      Partial<ScheduleEmployeeFilters>
    >({
      query: (filters) => ({
        url: '/schedule-employees',
        params: filters,
      }),
      providesTags: ['ScheduleEmployees'],
    }),
    getScheduleEmployee: builder.query<ScheduleEmployee, string>({
      query: (id) => `/schedule-employees/${id}`,
      providesTags: ['ScheduleEmployees'],
    }),
    addScheduleEmployee: builder.mutation<
      ScheduleEmployee,
      ScheduleEmployeePostMutationRequest
    >({
      query: (body) => ({
        url: '/schedule-employees',
        method: 'POST',
        body,
      }),
    }),
    updateScheduleEmployee: builder.mutation<
      ScheduleEmployee,
      ScheduleEmployeePatchMutationRequest
    >({
      query: ({ id, ...body }) => ({
        url: `/schedule-employees/${id}`,
        headers: { 'content-type': 'application/merge-patch+json' },
        method: 'PATCH',
        body: JSON.stringify(body),
      }),
      invalidatesTags: ['ScheduleEmployees'],
    }),
  }),
});

export const {
  useGetScheduleEmployeesQuery,
  useGetScheduleEmployeeQuery,
  useAddScheduleEmployeeMutation,
  useUpdateScheduleEmployeeMutation,
} = scheduleEmployeesApi;
